import { https } from "../http";
import store from "../store";
import {
  setAllSignature,
  setSignature,
  setSignatureLoading,
} from "../store/reducers/signature";
import { showError } from "../utils";
import { getProfile } from "./profile";

const createSignature = async (data) => {
  try {
    store.dispatch(setSignatureLoading(true));
    let response = await https().post("/signature/create-signature", data);
    if (response?.status === 200) {
      getSignatureById();
      getProfile();
      store.dispatch(setSignatureLoading(false));
      return response?.data;
    }
  } catch (error) {
    store.dispatch(setSignatureLoading(false));
    showError(error?.response?.data?.message, error?.response?.status);
    return false;
  }
};

const getSignatureById = async () => {
  try {
    store.dispatch(setSignatureLoading(true));
    let response = await https().get("/signature/get-signature");
    if (response?.status === 200) {
      store.dispatch(setSignature(response?.data));
      store.dispatch(setSignatureLoading(false));
      return response?.data;
    }
  } catch (error) {
    store.dispatch(setSignatureLoading(false));
    showError(error?.response?.data?.message, error?.response?.status);
    return false;
  }
};
const getSignatureByIdManual = async (id) => {
  try {
    store.dispatch(setSignatureLoading(true));
    let response = await https().get("/signature/get-signature", id);
    if (response?.status === 200) {
      store.dispatch(setSignature(response?.data));
      store.dispatch(setSignatureLoading(false));
      return response?.data;
    }
  } catch (error) {
    store.dispatch(setSignatureLoading(false));
    showError(error?.response?.data?.message, error?.response?.status);
    return false;
  }
};

const getAllSignatures = async () => {
  try {
    store.dispatch(setSignatureLoading(true));
    let response = await https().get("/signature/get-all-signatures");
    if (response?.status === 200) {
      store.dispatch(setAllSignature(response?.data));
      store.dispatch(setSignatureLoading(false));
      return response?.data;
    }
  } catch (error) {
    store.dispatch(setSignatureLoading(false));
    showError(error?.response?.data?.message, error?.response?.status);
    return false;
  }
};

const changeSignatureNotification = async (id) => {
  try {
    store.dispatch(setSignatureLoading(true));
    let response = await https().post(
      "/signature/change-signature-notification",
      id
    );
    if (response?.status === 200) {
      getSignatureById();
      store.dispatch(setSignatureLoading(false));
      return response;
    }
  } catch (error) {
    store.dispatch(setSignatureLoading(false));
    showError(error?.response?.data?.message, error?.response?.status);
    return false;
  }
};
// this api update only request status
const updateChangeSignature = async (data) => {
  try {
    store.dispatch(setSignatureLoading(true));
    let response = await https().put(
      "/signature/update-change-signature",
      data
    );
    if (response?.status === 200) {
      // getSignatureById();
      getProfile();
      store.dispatch(setSignatureLoading(false));
      return response;
    }
  } catch (error) {
    store.dispatch(setSignatureLoading(false));
    showError(error?.response?.data?.message, error?.response?.status);
    return false;
  }
};
// update whole signature
const updateSignature = async (data) => {
  console.log("🚀 ~ updateSignature ~ data:", data);
  try {
    store.dispatch(setSignatureLoading(true));
    let response = await https().put("/signature/update-signature", data);
    if (response?.status === 200) {
      getSignatureById();
      store.dispatch(setSignatureLoading(false));
      return response;
    }
  } catch (error) {
    store.dispatch(setSignatureLoading(false));
    showError(error?.response?.data?.message, error?.response?.status);
    return false;
  }
};

export {
  createSignature,
  getSignatureById,
  getAllSignatures,
  changeSignatureNotification,
  updateChangeSignature,
  updateSignature,
  getSignatureByIdManual,
};
